"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefetchGetFAQs = exports.useGetFAQs = void 0;
const getFaqContent_1 = __importDefault(require("@lumirental/lumi-web-sdk/dist/clients/cms/getFaqContent"));
const faqFactory_1 = __importDefault(require("@lumirental/lumi-web-sdk/dist/factories/cms/faqFactory"));
const Language_context_1 = require("../contexts/Language.context");
const config_1 = require("./config");
/**
 * Query Config
 * @param {Object} options
 * @property {UseQueryOptions} options.config
 * @property {string} options.appEnv
 * @returns Object
 */
const queryConfig = ({ config } = {}) => {
    return Object.assign({ queryKey: ['faq'], queryFn: () => (0, getFaqContent_1.default)(process.env.APP_ENV), enabled: false }, config);
};
/**
 * Query fetch/sync and format data
 */
const useGetFAQs = (options) => {
    var _a;
    const queryRes = (0, config_1.useFetch)(queryConfig(options));
    const { isArabic, language } = (0, Language_context_1.useLanguageContext)();
    const lang = isArabic ? 'ar-SA' : language;
    const { data } = queryRes;
    const faqContent = (_a = data === null || data === void 0 ? void 0 : data.filter((item) => item.locale === lang).map((faq) => (0, faqFactory_1.default)(faq))) !== null && _a !== void 0 ? _a : [];
    return Object.assign(Object.assign({}, queryRes), { faqContent });
};
exports.useGetFAQs = useGetFAQs;
const prefetchGetFAQs = (options) => (queryClient) => {
    return queryClient.fetchQuery(queryConfig(options));
};
exports.prefetchGetFAQs = prefetchGetFAQs;
